module.exports = __webpack_public_path__ + "static/NotAllWhoWander-97457f5a99994fd84cf572817dfc0818.jpg";